<!-- ============================================================== -->
<!-- Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">
            <div class="d-flex align-items-center">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a rouetLink="/mainview/dashboard" class="link">Dashboard</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page"> Product Sub Category Management</li>
                    </ol>
                </nav>
            </div>
            <h4 class="page-title">Product Sub Category Management</h4>
        </div>

    </div>
</div>
<!-- ============================================================== -->
<!-- End Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->


<div style="display: block;Width:12%;margin-left: 30px">
    <div class="mt-3">

        <a *ngIf="!show" href="javascript:void(0)" (click)="addProductSubCategory()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Add </span>
        </a>
        <a *ngIf="show" href="javascript:void(0)" (click)="addProductSubCategory()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Remove </span>
        </a>
        </div>
</div>
<!-- ============================================================== -->


<div *ngIf="show">
    <div>

        <div class="container-fluid">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="row">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <form #subCategory="ngForm" novalidate>
                                <div class="form-body">
                                    <h5 class="card-title">Product SubCategory</h5>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Sub Category Name </label>
                                                <input type="text" id="name" required #name="ngModel" name="name"
                                                    [(ngModel)]="subCategoryAddObj.name" class="form-control" rows="4">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!name.errors.required"
                                                    *ngIf="name.errors && (name.touched || name.dirty)">
                                                    This Field is Required</span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                           <!--/span-->
                                            <div class="col-md-3">
                                                <h5 class="card-title m-t-20"> <span
                                                        class="text-danger">*</span>Sub Category
                                                    Logo</h5>


                                                <div class="btn btn-info waves-effect waves-light" style="width:50%">
                                                    <input type="file" id="container"
                                                        accept="image/gif, image/jpeg, image/png"
                                                        (change)="fileChangeEvent($event)" required #logo="ngModel"
                                                        name="logo" [(ngModel)]="subCategoryAddObj.logo" class="upload">
                                                </div>
                                                <span class="text-danger" [hidden]="!logo.errors.required"
                                                    *ngIf="logo.errors && (logo.touched || logo.dirty)">*This
                                                    Field is required
                                                </span>
                                            </div>
                                            <img width="45.25em" height="46.25em" [src]="pic" height="150" width="200px"
                                            style="margin: 3px;"> <br />
                                        </div>
                                       
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="control-label">Category Name</label>
                                                    <select  class="form-control" required #categoryId="ngModel" name="categoryId"
                                                    [(ngModel)]="subCategoryAddObj.categoryId"
                                                    data-placeholder="Choose a Role Name" tabindex="1">
                                                        <option disabled="" value="" selected>Category</option>

                                                        <option *ngFor="let cl of categoriesList" value="{{cl._id}}">
                                                            {{cl.name}}</option>
                                                    </select>
                                                    <span class="text-danger" [hidden]="!categoryId.errors.required"
                                                        *ngIf="categoryId.errors && (categoryId.touched || categoryId.dirty)">*Please
                                                        select Category
                                                    </span>
                                                </div>
                                            </div>
                                            <!--/span-->
                                            <!-- <div class="col-md-6" style="margin-top: 30px">
                                                <div class="form-group">
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input"
                                                            id="customCheck1" (change)="check()">
                                                        <label class="custom-control-label" for="customCheck1">
                                                            Gender</label>
                                                    </div>

                                                </div>
                                                <div class="form-group" *ngIf="showCheck">

                                                    <div class="custom-control custom-radio custom-control-inline">
                                                        <input type="radio" id="male" name="gender"
                                                            [(ngModel)]="subCategoryAddObj.gender" value="male">
                                                       Male &nbsp;&nbsp;
                                                        <input type="radio" id="female" name="gender"
                                                            [(ngModel)]="subCategoryAddObj.gender" value="female">
                                                       Female &nbsp;&nbsp;
                                                        <input type="radio" id="kids" name="gender"
                                                        [(ngModel)]="subCategoryAddObj.gender" value="kids">
                                                    Kids &nbsp;&nbsp;
                                                    <input type="radio" id="unisex" name="gender"
                                                        [(ngModel)]="subCategoryAddObj.gender" value="unisex">
                                                   Unisex &nbsp;&nbsp;

                                                    </div>
                                                </div>
                                            </div> -->
                                            <!--/span-->

                                        </div>



                                </div>
                                <div class="form-actions m-t-40">
                                    <button type="submit" style="background-color: #67358c;color:white" class="btn"
                                        [disabled]="!subCategory.valid" (click)="saveSubCategory()">
                                        <i class="fa fa-check"></i> Submit</button>&nbsp;&nbsp;
                                    <button type="button" class="btn btn-dark" (click)="addProductSubCategory()"
                                        data-dismiss="modal">Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>
            <!-- ============================================================== -->
            <!-- End PAge Content -->
            <!-- ============================================================== -->
            <!-- ============================================================== -->
            <!-- Right sidebar -->
            <!-- ============================================================== -->
            <!-- .right-sidebar -->
            <!-- ============================================================== -->
            <!-- End Right sidebar -->
            <!-- ============================================================== -->
        </div>
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
    </div>
</div>


<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" >
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <diV class="row">
                                <div class="col-md-10">
                                    <label style="color: black;">All Sub Product Categories</label>
                                </div>

                                
                                <div class="col-md-2">

                                    <div id="zero_config_filter" class="dataTables_filter" >
                                        <button style="background-color: #e0e09e" (click)="exportTable()">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                            </diV>
                            <!-- <div *ngIf="showFilter" style="background-color: #e0e09e;width: 895px;">
                                <div class="container-fluid" style="color: black">
                                    <input type="radio" id="firstName" name="gender" [(ngModel)]="filterValueSelected" value="f" (change)="applyCustomizedFilter()" style="margin-top: 29px;"> First Name &nbsp;&nbsp;
                                    <input type="radio" id="lastName" name="gender" [(ngModel)]="filterValueSelected" value="l"  (change)="applyCustomizedFilter()"> Last Name &nbsp;&nbsp;
                                    <input type="radio" id="emailId" name="gender" [(ngModel)]="filterValueSelected" value="ei" (change)="applyCustomizedFilter()"> Email Address &nbsp;&nbsp;
                                    <input type="radio" id="mobile" name="gender" [(ngModel)]="filterValueSelected" value="mn"  (change)="applyCustomizedFilter()"> Mobile Number &nbsp;&nbsp;
                                   
                                   
                                </div>
                                <div style="margin-left: 820px">
                                   
                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>

                                </div>
                            </div> -->

                            <div>
                                <div>

                                    <mat-form-field>

                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table [dataSource]="dataSource" matSort>

                                       
                                        <ng-container matColumnDef="name">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub Category Name</th>
                                            <!-- <td *matCellDef="let row"  *ngIf="row.status==Active" style="padding-left: 14px;background-color: gray;" >{{row.firstName}}</td> -->

                                            <td *matCellDef="let row" >
                                                <div *ngIf="row.status==false"
                                                    style="background-color: #e8e1e1;height:50px;width:103%">
                                                    {{row.name}}</div>
                                                <div *ngIf="row.status==true">
                                                    {{row.name}}</div>
                                            </td>
                                        </ng-container>


                                       
                                        <ng-container matColumnDef="categoryName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Category Name</th>

                                            <td *matCellDef="let row">
                                                {{row.categoryName}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="logo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub Category Logo</th>
                                            <td *matCellDef="let row">
                                                <a target="blank" href="{{myurl+'Misc/Images/subcategorylogos/'+row._id}}">View</a>

                                               

                                            </td>
                                        </ng-container>

                                       
                                        <ng-container matColumnDef="adminUserName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Admin User
                                                Name</th>
                                            <!-- <td *matCellDef="let row"  *ngIf="row.status==Active" style="padding-left: 14px;background-color: gray;" >{{row.firstName}}</td> -->

                                            <td *matCellDef="let row">
                                                {{row.adminUserName}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub Category Status</th>
                                            <!-- <td *matCellDef="let row"  *ngIf="row.status==Active" style="padding-left: 14px;background-color: gray;" >{{row.firstName}}</td> -->

                                            <td *matCellDef="let row">
                                                <span *ngIf="row.status==true"> Active</span>
                                                <span *ngIf="row.status==false"> In Active</span>                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="createdDate">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
                                            <td *matCellDef="let row">
                                                {{row.createdDate|date}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="modifiedDate">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Modified Date</th>
                                            <td *matCellDef="let row">
                                                {{row.modifiedDate|date}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="Action">
                                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                                            <td *matCellDef="let row">
                                                
                                                <ul class="list-group list-group-flush">
                                                    <li class="list-group-item  friend-list mb-2">

                                                        <div class="dropdown show float-right list-block">

                                                            <a class="userDropdown" href="#" role="button"
                                                                id="userDropdown" data-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false"
                                                                style="padding-right: 170px;"></a>
                                                            <div class="dropdown-menu dropdown-menu-right"
                                                                aria-labelledby="userDropdown">
                                                                <button class="dropdown-item" data-toggle="modal"
                                                                    data-target="#responsive" 
                                                                    (click)="getSubCategoryById(row._id)">
                                                                    <i class="fa fa-address-card"
                                                                        aria-hidden="true"></i>&nbsp;&nbsp;Edit</button>
                                                                <button class="dropdown-item" 
                                                                    (click)="deleteSubCategory(row._id)">
                                                                    <i class="fa fa-trash p-2"
                                                                        aria-hidden="true"></i>Delete</button>
                                                                <div>
                                                                    <mat-slide-toggle 
                                                                        (change)="onChange($event,row._id)"
                                                                        [checked]="row.status">
                                                                        <span *ngIf="row.status==false">
                                                                            In Active</span>
                                                                        <span *ngIf="row.status==true">
                                                                            Active</span>
                                                                    </mat-slide-toggle>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>

                        </div>
                    </div>
                    <mat-paginator style="margin-right:200px" [length]="100" [pageSize]="10"
                        [pageSizeOptions]="[5, 10, 25,100]" showFirstLastButtons>
                    </mat-paginator>

                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->
<!-- ============================================================== -->
<div id="responsive" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content bigModel" style="width:900px">
            <div class="modal-header">
                <h4>Edit Sub Category Management</h4>
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <form #subCategoryUpdate="ngForm" novalidate>
                    <div class="form-body">
                        <hr>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Sub Category Name</label>

                                   <input type="text" id="name" required #name="ngModel" name="name"
                                        [(ngModel)]="subCategoryAddObj.name" class="form-control" rows="4">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!name.errors.required"
                                        *ngIf="name.errors && (name.touched || name.dirty)">
                                        This Field is Required</span>
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Category Name</label>
                                    <select  class="form-control" required #categoryId="ngModel" name="categoryId"
                                    [(ngModel)]="subCategoryAddObj.categoryId"
                                    data-placeholder="Choose a Role Name" tabindex="1">
                                        <option disabled="" value="" selected>Category</option>

                                        <option *ngFor="let cl of categoriesList" value="{{cl._id}}">
                                            {{cl.name}}</option>
                                    </select>
                                    <span class="text-danger" [hidden]="!categoryId.errors.required"
                                        *ngIf="categoryId.errors && (categoryId.touched || categoryId.dirty)">*Please
                                        select Category
                                    </span>
                                </div>
                            </div>
                             

                            </div>
                           
                            <div class="row">
                                 <!--/span-->
                                 <div class="col-md-6">
                                    <label class="control-label">Sub Category logo</label>


                                    <div class="btn btn-info waves-effect waves-light">
                                        <input type="file" id="container"
                                            accept="image/gif, image/jpeg, image/png"
                                            (change)="fileChangeEvent($event)"  #logo="ngModel"
                                            name="logo" [(ngModel)]="subCategoryAddObj.logo" class="upload">
                                    </div>
                                    <span class="text-danger" [hidden]="!logo.errors.required"
                                        *ngIf="logo.errors && (logo.touched || logo.dirty)">*This
                                        Field is required
                                    </span>
                                </div>
                                <img width="45.25em" height="46.25em" [src]="pic" height="150" width="200px"
                                style="margin: 3px;"> <br />
                                <!--/span-->
                                <!-- <div class="col-md-6" style="margin-top: 30px">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input"
                                                id="customCheck1" (change)="check()">
                                            <label class="custom-control-label" for="customCheck1">
                                                Gender</label>
                                        </div>

                                    </div>
                                    <div class="form-group" *ngIf="showCheck">

                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="male" name="gender"
                                                [(ngModel)]="subCategoryAddObj.gender" value="male">
                                           Male &nbsp;&nbsp;
                                            <input type="radio" id="female" name="gender"
                                                [(ngModel)]="subCategoryAddObj.gender" value="female">
                                           Female &nbsp;&nbsp;
                                            <input type="radio" id="kids" name="gender"
                                            [(ngModel)]="subCategoryAddObj.gender" value="kids">
                                        Kids &nbsp;&nbsp;
                                        <input type="radio" id="unisex" name="gender"
                                            [(ngModel)]="subCategoryAddObj.gender" value="unisex">
                                       Unisex &nbsp;&nbsp;

                                        </div>
                                    </div>
                                </div> -->
                                <!--/span-->

                            </div>
                        



                    </div>
                    <div class="form-actions m-t-40">
                        <button type="submit" style="background-color: #67358c;color:white" class="btn"
                            [disabled]="!subCategoryUpdate.valid" data-dismiss="model" (click)="updateSubCategory()">
                            <i class="fa fa-check"></i> Update</button>&nbsp;&nbsp;
                        <button type="button" class="btn btn-dark" data-dismiss="model"
                            data-dismiss="modal">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- ============================================================== -->
<!-- ============================================================== -->